module.exports = __webpack_public_path__ + "media/images/en/upload-print-5703c5ed9f3137863b4610782f43d300.png";